requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('slider-component')) {
      class SliderComponent extends HTMLElement {
        constructor() {
          super();
          this.element = this;
        }

        connectedCallback() {
          const requiredStyles = ['component-slider'];

          if (this.querySelector('.card')) {
            requiredStyles.push('component-card');
          }

          scriptController.onStyleReady(() => {
            this.initializeSlider();
          }, requiredStyles);
        }

        getElementsWithLogicalOrder(selector) {
          const elements = Array.from(this.querySelectorAll(selector));
          return elements;
        }

        initializeSlider() {
          if (!themeBase.isSlider(this)) return;

          this.accordionButton = this.closest('accordion-button');

          if (this.accordionButton && !this.accordionButton.classList.contains('animated-dropdown--active')) {
            this.accordionButton.addEventListener('opened', () => {
              if (this.accordionButton.classList.contains('slider-loaded')) return;
              this.initializeSlider();
              this.accordionButton.classList.add('slider-loaded');
            });
            return;
          }

          if (!Shopify.designMode) {
            const popupModal = this.closest('.popup-modal');

            if (popupModal && !popupModal.hasAttribute('open')) {
              popupModal.addEventListener('modalOpened', this.initializeSlider.bind(this), {
                once: true
              });
              return;
            }
          }

          this.slider = this.querySelector('ul.slider, [id^="Slider-"]');

          if (!this.slider) return;

          this.sliderItems = this.getElementsWithLogicalOrder('ul.slider li, [id^="Slide-"]');
          this.bullets = this.getElementsWithLogicalOrder('button[name="bullet"]');
          this.currentPageElement = this.querySelector('.slider-counter--current');
          this.pageTotalElement = this.querySelector('.slider-counter--total');
          this.prevButton = this.querySelector('button[name="previous"]');
          this.nextButton = this.querySelector('button[name="next"]');

          this.enableSliderLooping = false;

          this.initSlider();
        }

        initPages() {
          this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

          if (!this.slider || this.sliderItemsToShow.length < 2) return;

          this.bulletsToShow = Array.from(this.bullets).filter((element) => element.clientWidth > 0);
          this.sliderItemsBanner = Array.from(this.sliderItems).map((element) => element.querySelector('.banner'));
          this.sliderItemsMedia = Array.from(this.sliderItems).map((element) => element.querySelector('.slideshow__media'));
          this.sliderItemsAdditionalMedia = Array.from(this.sliderItems).map((element) => element?.querySelectorAll('.slideshow__additional-media'));
          this.sliderItemsImgs = Array.from(this.sliderItemsMedia).map((element) => element?.querySelectorAll('img'));
          this.sliderItemsContent = Array.from(this.sliderItems).map((element) => element.querySelector('.banner__content'));
          this.sliderItemsBox = Array.from(this.sliderItems).map((element) => element.querySelector('.banner__box'));
          this.sliderItemsContentElements = Array.from(this.sliderItemsContent).map((element) => element?.querySelectorAll('.slideshow__content-element'));
          this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
          this.sliderItemOffset = Math.abs(getLogicalOffsetLeft(this.sliderItemsToShow[1]) - getLogicalOffsetLeft(this.sliderItemsToShow[0]));
          this.sliderItemGap = Math.abs(getLogicalOffsetLeft(this.sliderItemsToShow[0]) + this.sliderItemsToShow[0].clientWidth - getLogicalOffsetLeft(this.sliderItemsToShow[1]));
          this.slidesPerPage = Math.round(
            (this.slider.clientWidth - getLogicalOffsetLeft(this.sliderItemsToShow[0])) / this.sliderItemOffset
          );
          this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
          this.slidePositionRatio = [];
          this.slidePositionFullPercent = [];
          this.slidePositionPercent = [];
          this.slidePositionIsActive = [];
          this.slideStep = [];

          if (this.bulletsToShow.length) {
            this.bulletsToShow.forEach((element, index) => {
              element.onclick = null;
              element.addEventListener('click', this.onBulletClick.bind(this, index));
            });
          }

          this.update();
        }

        initSlider() {
          this.initPages();

          if (!this.sliderItemsToShow.length && !this.resizeObserver) {
            this.resizeObserver = new ResizeObserver((entries) => {
              if (this.initSlider()) {
                this.resizeObserver.unobserve(this.slider);
              }
            });
            this.resizeObserver.observe(this.slider);
          }


          if (this.sliderItemsToShow.length < 2) {
            return false;
          }

          this.slider.style.scrollBehavior = 'auto';
          logicalScrollTo(this.slider, {
            left: 0
          });
          this.slider.style.scrollBehavior = '';

          this.slider.addEventListener('scroll', this.update.bind(this));

          if (this.prevButton) {
            this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
          }
          if (this.nextButton) {
            this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
          }
          this.initTouchSwipeFallback();
          if (this.dataset.autoplay !== undefined && this.sliderItemsToShow.length > 1) {
            this.startAutoplay();
          }

          const resizeObserver = new ResizeObserver((entries) => requestAnimationFrame(() => this.initPages()));
          resizeObserver.observe(this.slider);

          this.classList.add('js-slider-initialized');
          window.lazyImages.find();
          return true;
        }

        resetPages() {
          this.sliderItems = this.getElementsWithLogicalOrder('ul.slider li, [id^="Slide-"]');
          this.initPages();
        }

        calculateSlidePosition() {
          const step = this.getStep();
          let stepGroup = 0;

          this.sliderItemsToShow.forEach((item, index) => {
            if (index === 0) {
              this.slidePositionLimit = item.clientWidth / (this.slider.clientWidth / 100) / 2;
            }

            const slideOffset = getLogicalRect(item).left - getLogicalRect(this.slider).left;

            this.slidePositionFullPercent[index] = Math.round(slideOffset / (this.slider.clientWidth / 100));
            this.slidePositionPercent[index] = this.slidePositionFullPercent[index];
            this.slidePositionRatio[index] = this.slidePositionPercent[index] / 100;
            this.slidePositionIsActive[index] = this.slidePositionPercent[index] >= this.slidePositionLimit * -1 && this.slidePositionPercent[index] <= 100 - this.slidePositionLimit;

            stepGroup = Math.floor(index / step);
            this.slideStep[index] = stepGroup;
          });

          this.slideStep[this.slideStep.length - step] = stepGroup;
        }

        getStep() {
          let step = 1;

          if (this.slider.dataset.step) {
            step = this.slider.dataset.step;

            if (themeBase.isTablet && this.slider.dataset.stepTablet) {
              step = this.slider.dataset.stepTablet;
            } else if (themeBase.isMobile && this.slider.dataset.stepMobile) {
              step = this.slider.dataset.stepMobile;
            }
          } else if (!themeBase.isDesktop && this.slider.classList.contains('slider--two-in-row')) {
            step = 2;
          }

          return new Number(step);
        }

        update() {
          if ((!this.slider || !this.nextButton) && this.dataset.autoplay === undefined) return;

          this.calculateSlidePosition();

          const previousPage = this.currentPage;

          for (let index = 0; index < this.slidePositionIsActive.length; index++) {
            if (this.slidePositionIsActive[index]) {
              this.currentPage = index;
              break;
            }
          }


          if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage + 1;
            this.pageTotalElement.textContent = this.totalPages;
          }

          if (this.currentPage != previousPage) {
            this.dispatchEvent(
              new CustomEvent('slideChanged', {
                detail: {
                  currentPage: this.currentPage,
                  currentElement: this.sliderItemsToShow[this.currentPage],
                },
              })
            );
          }

          this.bulletsToShow.forEach((element, index) => {
            element.classList[index === this.slideStep[this.currentPage] ? 'add' : 'remove']('active');
          });

          if (this.enableSliderLooping) return;

          if (this.prevButton) {
            if (this.isSlideVisible(this.sliderItemsToShow[0]) && getLogicalScrollLeft(this.slider) === 0) {
              this.prevButton.setAttribute('disabled', 'disabled');
            } else {
              this.prevButton.removeAttribute('disabled');
            }
          }

          if (this.nextButton) {
            if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
              this.nextButton.setAttribute('disabled', 'disabled');
            } else {
              this.nextButton.removeAttribute('disabled');
            }
          }

        }

        isSlideVisible(element, offset = 0) {
          if (!this.slider) return true;
          const lastVisibleSlide = this.slider.clientWidth + getLogicalScrollLeft(this.slider) - offset + this.sliderItemGap;
          return getLogicalOffsetLeft(element) + element.clientWidth <= lastVisibleSlide && getLogicalOffsetLeft(element) >= getLogicalScrollLeft(this.slider);
        }

        initTouchSwipeFallback() {
          if (this.touchSwipeFallbackInitialized || !window.ios || this.tagName !== 'SLIDER-COMPONENT') return;

          this.touchSwipeFallbackInitialized = true;

          this.slider.addEventListener('touchstart', this.onSliderTouchStart.bind(this), {
            passive: true
          });
          this.slider.addEventListener('touchmove', this.onSliderTouchMove.bind(this), {
            passive: true
          });
          this.slider.addEventListener('touchend', this.onSliderTouchEnd.bind(this), {
            passive: true
          });
          this.slider.addEventListener('touchcancel', this.onSliderTouchEnd.bind(this), {
            passive: true
          });
          this.slider.addEventListener('scroll', this.onSliderTouchScroll.bind(this), {
            passive: true
          });
          this.slider.addEventListener('click', this.onSliderTouchClick.bind(this), true);
        }

        onSliderTouchStart(event) {
          if (!event.touches || event.touches.length !== 1) return;

          this.touchInProgress = true;
          this.touchNativeScrollStarted = false;
          this.touchStartX = getLogicalClientX(event.touches[0]);
          this.touchStartY = event.touches[0].clientY;
          this.touchCurrentX = this.touchStartX;
          this.touchCurrentY = this.touchStartY;
          this.touchStartScrollLeft = getLogicalScrollLeft(this.slider);
        }

        onSliderTouchMove(event) {
          if (!this.touchInProgress || !event.touches || event.touches.length !== 1) return;

          this.touchCurrentX = getLogicalClientX(event.touches[0]);
          this.touchCurrentY = event.touches[0].clientY;

          if (this.hasNativeTouchScrollStarted()) {
            this.touchNativeScrollStarted = true;
          }
        }

        onSliderTouchScroll() {
          if (!this.touchInProgress) return;

          if (this.hasNativeTouchScrollStarted()) {
            this.touchNativeScrollStarted = true;
          }
        }

        onSliderTouchEnd(event) {
          if (!this.touchInProgress) return;

          if (event?.changedTouches?.length) {
            this.touchCurrentX = getLogicalClientX(event.changedTouches[0]);
            this.touchCurrentY = event.changedTouches[0].clientY;
          }

          const shouldSwitchSlide =
            event?.type === 'touchend' &&
            !this.touchNativeScrollStarted &&
            this.hasHorizontalTouchIntent() &&
            !this.hasNativeTouchScrollStarted();

          this.touchInProgress = false;

          if (shouldSwitchSlide) {
            this.switchTouchFallbackSlide();
          }
        }

        onSliderTouchClick(event) {
          if (!this.touchSuppressClick) return;

          event.preventDefault();
          event.stopPropagation();
          this.touchSuppressClick = false;
        }

        hasHorizontalTouchIntent() {
          const diffX = this.touchCurrentX - this.touchStartX;
          const diffY = this.touchCurrentY - this.touchStartY;

          return Math.abs(diffX) > 8 && Math.abs(diffX) > Math.abs(diffY) * 1.15;
        }

        hasNativeTouchScrollStarted() {
          return Math.abs(getLogicalScrollLeft(this.slider) - this.touchStartScrollLeft) > 1;
        }

        switchTouchFallbackSlide() {
          const direction = this.touchCurrentX - this.touchStartX < 0 ? 1 : -1;
          const step = this.getStep();
          const currentPage = this.currentPage || 0;
          const targetPage = Math.max(0, Math.min(currentPage + direction * step, this.totalPages - 1));

          this.touchSuppressClick = true;
          setTimeout(() => {
            this.touchSuppressClick = false;
          }, 400);

          if (targetPage === currentPage) {
            return;
          }

          logicalScrollTo(this.slider, {
            left: targetPage * this.sliderItemOffset,
            behavior: 'auto'
          });
          this.update();
        }

        onButtonClick(event, button) {
          if (event) {
            event.preventDefault();
          }

          const step = this.getStep();
          button = button || event.currentTarget.name;

          this.slideScrollPosition =
            button === 'next' ?
            (this.currentPage + step) * this.sliderItemOffset :
            (this.currentPage - step) * this.sliderItemOffset;
          this.setSlidePosition(this.slideScrollPosition);
        }

        setSlidePosition(position) {
          logicalScrollTo(this.slider, {
            left: position,
            behavior: 'smooth'
          });
        }

        onBulletClick(index, event) {
          if (event) event.preventDefault();

          index = index * this.getStep();

          this.slideScrollPosition = index * this.sliderItemOffset;
          this.setSlidePosition(this.slideScrollPosition);

        }

        toNextSlide() {
          let nextSlide;

          if (this.bulletsToShow.length) {

            for (let index = 0; index < this.bulletsToShow.length; index++) {
              const element = this.bulletsToShow[index];
              if (element.classList.contains('active')) {
                nextSlide = index + 1;
                if (nextSlide >= this.bulletsToShow.length) {
                  nextSlide = 0;
                }
                break;
              }
            }
          } else {
            nextSlide = this.currentPage + 1;
            if (nextSlide >= this.sliderItemsToShow.length) {
              nextSlide = 0;
            }
          }

          if (nextSlide === undefined) return;
          if (this.bulletsToShow.lenght) {
            this.bulletsToShow.forEach(element => element.classList.remove('active'));
            this.bulletsToShow[nextSlide].classList.add('active');
          }

          this.onBulletClick(nextSlide);
        }

        startAutoplay() {
          setInterval(() => {
            this.toNextSlide();
          }, +this.dataset.autoplay);
        }
      }

      window.SliderComponent = SliderComponent;
      scriptController.scripts.push('slider-component.js');
      customElements.define('slider-component', SliderComponent);
    }
  });
});